import element from 'element-ui';
import router from '../router'

let lastTime = new Date().getTime();
let time = null;
let currentTime = new Date().getTime()
let timeOut = (60*60*60) * 60 * 1000  //设置超时时间: 30分钟
import {bus} from './../bus'


window.onload = function () {
  window.document.onmousedown = function () {
    // 保存最新的操作时间到storage中
    window.localStorage.setItem("lastTime", new Date().getTime())
  }
};

function checkTimeout() {
  //更新当前时间
  currentTime = new Date().getTime()

  lastTime = window.localStorage.getItem("lastTime");

  let token =window.localStorage.getItem("access-token");
  //判断是否存在token
  if(token){
    //判断是否超时
    if (currentTime - lastTime > timeOut) {
      window.clearInterval(time);
      time=null;
      // 清除storage的数据(登陆信息和token)
      element.MessageBox.confirm("会话超时，您的身份已过期，请重新登录", "提示", {
        confirmButtonText: '确定',
        showClose:true,
        showCancelButton: false,
        type: 'warning'
      }).then(() => {
        console.log(time)//clearInterval
        window.localStorage.removeItem('access-token');
        window.localStorage.removeItem('menus');
        window.localStorage.removeItem('userinfo')
        router.replace("/login")
        // bus.$emit('goto', '/login')
        // this.$router.push('/login'); //跳转 回登陆页面
      }).catch(() => {
        // element.Message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      });
    }

  }

}

export default function () {
  /* 定时器 间隔10秒检测是否长时间未操作页面 */
  time= window.setInterval(checkTimeout, 10000);
}



// WEBPACK FOOTER //
// ./src/utils/testing.js